export default __webpack_public_path__ + "static/docs/app-distribution-agreement.97ce9f7b00f835f4dfefe60f74fce698.html";